import { createSlice } from "@reduxjs/toolkit";

export interface ResponderState {
    dispatchers: any[]
}
const initialState: ResponderState = {
    dispatchers: []
}

const responderSlice = createSlice({
    name: "responder",
    initialState,
    reducers: {
        setDispatcher: (state: ResponderState, actions) => {
            state.dispatchers = actions.payload;
        }
    },

});

export const { setDispatcher } =
    responderSlice.actions;
export default responderSlice.reducer;